

import Swiper from 'vux/src/components/swiper/swiper.vue'

export default {
components: {
Swiper
},
data () {
return {
bannerList: [
{
url: 'javascript:',
img: 'http://img.luckytype.com/portal/banner1a.png'
},
{
url: 'javascript:',
img: 'http://img.luckytype.com/portal/banner3.png'
},
{
url: 'javascript:',
img: 'http://img.luckytype.com/portal/banner4.png'
}
],
zhaopaiList: [
{
url: 'javascript:',
img: 'http://img.luckytype.com/portal/zhaopai1.png'
},
{
url: 'javascript:',
img: 'http://img.luckytype.com/portal/zhaopai2.png'
},
{
url: 'javascript:',
img: 'http://img.luckytype.com/portal/zhaopai3.png'
},
{
url: 'javascript:',
img: 'http://img.luckytype.com/portal/zhaopai3a.png'
},
{
url: 'javascript:',
img: 'http://img.luckytype.com/portal/zhaopai4.png'
},
{
url: 'javascript:',
img: 'http://img.luckytype.com/portal/zhaopai5.png'
},
{
url: 'javascript:',
img: 'http://img.luckytype.com/portal/zhaopai6.png'
},
{
url: 'javascript:',
img: 'http://img.luckytype.com/portal/zhaopai7.png'
},
{
url: 'javascript:',
img: 'http://img.luckytype.com/portal/zhaopai8.png'
},
{
url: 'javascript:',
img: 'http://img.luckytype.com/portal/zhaopai9.png'
}
],
ledunList: [
{
url: 'javascript:',
img: 'http://img.luckytype.com/portal/ledun1.png'
},
{
url: 'javascript:',
img: 'http://img.luckytype.com/portal/ledun2.png'
},
{
url: 'javascript:',
img: 'http://img.luckytype.com/portal/ledun3.png'
},
{
url: 'javascript:',
img: 'http://img.luckytype.com/portal/ledun4.png'
},
{
url: 'javascript:',
img: 'http://img.luckytype.com/portal/ledun5.png'
},
{
url: 'javascript:',
img: 'http://img.luckytype.com/portal/ledun6.png'
},
{
url: 'javascript:',
img: 'http://img.luckytype.com/portal/ledun7.png'
},
{
url: 'javascript:',
img: 'http://img.luckytype.com/portal/ledun8.png'
},
{
url: 'javascript:',
img: 'http://img.luckytype.com/portal/ledun9.png'
}
],
juzhenList: [
{
url: 'javascript:',
img: 'http://img.luckytype.com/portal/juzhen1.png'
},
{
url: 'javascript:',
img: 'http://img.luckytype.com/portal/juzhen2.png'
},
{
url: 'javascript:',
img: 'http://img.luckytype.com/portal/juzhen3.png'
},
{
url: 'javascript:',
img: 'http://img.luckytype.com/portal/juzhen4.png'
},
{
url: 'javascript:',
img: 'http://img.luckytype.com/portal/juzhen5.png'
},
{
url: 'javascript:',
img: 'http://img.luckytype.com/portal/juzhen6.png'
},
{
url: 'javascript:',
img: 'http://img.luckytype.com/portal/juzhen7.png'
}
],
shanlinList: [
{
url: 'javascript:',
img: 'http://img.luckytype.com/portal/shanlin1.png'
},
{
url: 'javascript:',
img: 'http://img.luckytype.com/portal/shanlin2.png'
},
{
url: 'javascript:',
img: 'http://img.luckytype.com/portal/shanlin3.png'
},
{
url: 'javascript:',
img: 'http://img.luckytype.com/portal/shanlin4.png'
},
{
url: 'javascript:',
img: 'http://img.luckytype.com/portal/shanlin5.png'
},
{
url: 'javascript:',
img: 'http://img.luckytype.com/portal/shanlin6.png'
},
{
url: 'javascript:',
img: 'http://img.luckytype.com/portal/shanlin7.png'
},
{
url: 'javascript:',
img: 'http://img.luckytype.com/portal/shanlin8.png'
},
{
url: 'javascript:',
img: 'http://img.luckytype.com/portal/shanlin9.png'
}
]
}
},
mounted () {
},
methods: {
onBuy (val) {
if (val === 'zhaopai') {
open('https://item.taobao.com/item.htm?spm=a230r.1.14.1.21e85e41CPNqVN&id=563405060677&ns=1&abbucket=15#detail')
} else if (val === 'ledun') {
open('https://item.taobao.com/item.htm?spm=a230r.1.14.12.21e85e41CPNqVN&id=563406620962&ns=1&abbucket=15#detail')
} else if (val === 'juzhen') {
open('https://item.taobao.com/item.htm?spm=a230r.1.14.23.21e85e41CPNqVN&id=563576458770&ns=1&abbucket=15#detail')
} else if (val === 'zaishanlin') {
open('https://item.taobao.com/item.htm?spm=a230r.1.14.18.21e85e41CPNqVN&id=563577006791&ns=1&abbucket=15#detail')
} else if (val === 'vip') {
open('https://item.taobao.com/item.htm?spm=a230r.1.14.7.21e85e41CPNqVN&id=563509473751&ns=1&abbucket=15#detail')
}
},
toBeiAn () {
open('https://beian.miit.gov.cn/')
}
}
}



// WEBPACK FOOTER //
// ./src/components/Mobile.vue